import {Component} from "@angular/core";
import {User, UserRole} from "../../../models/user";
import {Agencies, AgencyAddress} from "../../../models/agencies";
import {AgencyService} from "../../../services/agency.service";
import {UtilService} from "../../../services/util.service";
import {UserService} from "../../../services/user.service";
import {finalize} from "rxjs";

@Component({
    selector: 'app-manage-agency-contacts',
    templateUrl: './manage-agency-contacts.component.html',
    styleUrl: './manage-agency-contacts.component.scss',
    standalone: false
})
export class ManageAgencyContactsComponent {

  protected readonly UserRole = UserRole;
  userProfile!: User;
  selectedAgencies!: Agencies;
  addOrEditInd: 'A'|'E'|null = null;
  agencyContactList?: User[];
  selectedUser: User|null|undefined = null;
  agencyAddress?: AgencyAddress;
  editAddress = false;
  saving = false;

  constructor(private agencyService: AgencyService,
              private utilService: UtilService,
              private userService: UserService) {
  }

  onSelectedAgencies(event: any) {
    this.selectedAgencies = event;
    console.debug(this.selectedAgencies);

    let tier1Agency = this.selectedAgencies.tier1Agency;
    let tier2Agency = this.selectedAgencies.tier2Agency;

    if (tier1Agency.agency_Id) {
      this.agencyService.getListOfAgencyPOC(tier1Agency.agency_Id, tier2Agency?.agency_Id).subscribe(agencyContacts => {
        if (agencyContacts) {
          this.agencyContactList = agencyContacts.user_Info_List;
          console.debug(this.agencyContactList);

          if (this.agencyContactList?.length > 0) {
            const addressContact = this.agencyContactList[0];

            this.agencyAddress = {
              address1: addressContact.address1,
              address2: addressContact.address2,
              city: addressContact.city,
              state: addressContact.state,
              zipCode: addressContact.zip_Code,
              country: addressContact.country,
              tier1_agency_id: this.selectedAgencies.tier1Agency.agency_Id,
              tier2_agency_id: this.selectedAgencies.tier2Agency?.agency_Id
            };

            this.agencyContactList = this.agencyContactList.map(contact => {
              contact.old_email = contact.email;
              return contact;
            });
          } else {
            this.agencyAddress = undefined;
          }
        } else {
          this.agencyAddress = undefined;
        }
      });
    } else {
      this.agencyContactList = undefined;
    }

  }

  setAddOrEditInd(ind: 'A'|'E', selectedUser?: User) {
    this.addOrEditInd = ind;
    this.selectedUser = selectedUser;

    if (this.addOrEditInd === 'A') {
      this.selectedUser = JSON.parse('{}');
    }
  }

  handleContactForm(eventPayload: any) {
    const eventCode = eventPayload?.eventCode || eventPayload;
    if (eventCode === 'S') {
      this.saving = true;
    }

    if (this.editAddress) {
      if (eventCode === 'S') {
        const agencyAddress: AgencyAddress = {
          address1: eventPayload.savedUser.address1,
          address2: eventPayload.savedUser.address2,
          city: eventPayload.savedUser.city,
          state: eventPayload.savedUser.state,
          zipCode: eventPayload.savedUser.zip_Code === '' ? null : eventPayload.savedUser.zip_Code,
          country: eventPayload.savedUser.country,
          tier1_agency_id: this.selectedAgencies.tier1Agency.agency_Id,
          tier2_agency_id: this.selectedAgencies.tier2Agency?.agency_Id
        }

        this.agencyService.updateAgencyAddress(agencyAddress)
          .pipe(finalize(() => this.saving = false))
          .subscribe(response => {
            if (response.success) {
              this.utilService.displayDialogMessage("Changes applied", "Agency address updated.");
              this.onSelectedAgencies(this.selectedAgencies);
              this.selectedUser = null;
              this.editAddress = false;
            } else {
              this.utilService.displayDialogMessage("Error", "There was a problem updating the agency address.");
            }
        });
      } else {
        // cancel
        this.selectedUser = null;
        this.editAddress = false;
      }
    } else {
      if (eventCode === 'S') {
        this.addOrUpdateAgencyContact(eventPayload.savedUser);
      } else if (eventCode === 'C')  {
        // Cancel Register or Update
        if (this.addOrEditInd === 'A') {
          // If Register is cancelled
          this.selectedUser = null;
        }

        this.addOrEditInd = null;
      } else if (eventCode === 'D') {
        this.handleDeleteAgencyContact();
      }

    }

  }

  private addOrUpdateAgencyContact(savedUser: User) {
    // Register User

    if (this.addOrEditInd === 'A' && this.agencyAddress) {
      savedUser.address1 = this.agencyAddress.address1;
      savedUser.address2 = this.agencyAddress.address2;
      savedUser.city = this.agencyAddress.city;
      savedUser.state = this.agencyAddress.state;
      savedUser.zip_Code = this.agencyAddress.zipCode;
      savedUser.country = this.agencyAddress.country;
    }

    let formData = this.getContactFormData(savedUser);

    if (this.addOrEditInd === 'A') {
      this.agencyService.registerAgencyInfo(formData)
        .pipe(finalize(() => this.saving = false))
        .subscribe(response => {
          if (response.success) {
            this.utilService.displayDialogMessage("Changes applied", "Agency contact registered.");
            this.onSelectedAgencies(this.selectedAgencies);
            this.selectedUser = null;
            this.addOrEditInd = null;
          } else {
            this.utilService.displayDialogMessage("Error", "There was a problem registering the agency contact.");
          }
      });

    } else {
      this.agencyService.updateAgencyInfo(formData)
        .pipe(finalize(() => this.saving = false))
        .subscribe(response => {
        if (response.success) {
          this.utilService.displayDialogMessage("Changes applied", "Agency contact updated.");
          this.onSelectedAgencies(this.selectedAgencies);
          this.selectedUser = null;
          this.addOrEditInd = null;
        } else {
          this.utilService.displayDialogMessage("Error", "There was a problem updating the agency contact.");
        }
      });
    }
  }

  private getContactFormData(savedUser: User) {
    if (!savedUser) return {};

    let formData = {
      prefix: savedUser.prefix,
      firstName: savedUser.first_Name,
      middle_initial: savedUser.middle_initial,
      lastName: savedUser.last_Name,
      suffix: savedUser.suffix,
      email: savedUser.email,
      phoneNo: savedUser.phone_No,
      faxNo: savedUser.fax_No,

      address1: savedUser.address1,
      address2: savedUser.address2,
      city: savedUser.city,
      state: savedUser.state,
      zipCode: savedUser.zip_Code,
      country: savedUser.country,

      tier1_agency_id: this.selectedAgencies.tier1Agency.agency_Id,
      tier2_agency_id: this.selectedAgencies.tier2Agency?.agency_Id,

      isGAO_User: "N",
      old_email: savedUser.old_email,
    }

    return formData;
  }

  private handleDeleteAgencyContact() {
    this.utilService.displayDialogMessage("DANGER!!: Deleting Agency Contact!",
      "You are about to delete the agency contact " + this.selectedUser?.first_Name + " " + this.selectedUser?.last_Name,
      {subtitle:"Are you sure?", confirmText:"DELETE", cancelBtn:true, confirmButtonColor:"warn", cancelButtonColor:"primary"})
      .subscribe(res => {
        if (res) {

          this.userService.deleteUser({
            isGAO_User: 'N',
            user_Id: this.selectedUser?.user_Id
          }).subscribe((response) => {
            console.debug(response);
            if (response.isSuccess) {
              this.handleDeleteSuccess();
            } else {
              this.utilService.displayDialogMessage("Error", "There was a problem deleting the agency contact.");
            }
          })
        }
      });
  }

  private handleDeleteSuccess() {
    this.utilService.displayDialogMessage("Changes applied", "Agency contact deleted.");
    this.onSelectedAgencies(this.selectedAgencies);
    this.selectedUser = null;
    this.addOrEditInd = null;
  }

  onAddressUpdate() {
    this.selectedUser = JSON.parse('{}');

    if (this.agencyAddress && this.selectedUser) {
      this.selectedUser.address1 = this.agencyAddress.address1;
      this.selectedUser.address2 = this.agencyAddress.address2;
      this.selectedUser.city = this.agencyAddress.city;
      this.selectedUser.state = this.agencyAddress.state;
      this.selectedUser.zip_Code = this.agencyAddress.zipCode;
      this.selectedUser.country = this.agencyAddress.country;
    }

    this.editAddress = true;
  }
}
